import { AppState } from '../../redux/initialStates/AppState';
import { TagsBadgesListState } from './TagsBadgesListState';

export const selectTagsBadgesState = (state: AppState): TagsBadgesListState => state.tagsBadges.tagsBadgesList;
